module.exports = __webpack_public_path__ + "static/media/KitchenModeOff.3bcf236f.svg";